module.exports = __webpack_public_path__ + "static/img/Tylor-Bunting.1b6e917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tylor-Bunting.jpg
// module id = hUb3
// module chunks = 0